import React from 'react';
import {connect} from "react-redux";
import getCustomerList from "../../actions/getCustomerList";
import {Form} from 'antd';
import MainLayout from "../Layout/Layout";
import showLogin from "../../actions/showLogin";
import getReportPreview from "../../actions/getReportPreview";
import ReportResultTable from "../ReportResultTable/ReportResultTable";
import {CustomerFilterItem, DateRangeFilterItem, ReportFilterActions, ReportFilterHeader} from "../ReportFilters/ReportFilters";
import {decodeBase64ToText, handleBase64Response, parseCsvText} from "../../utils";

class SMSOperations extends React.Component
{
    state={report:null,base64Report:null};

    componentDidMount()
    {
        if(!this.props.login.tokenId || !this.props.login.profileObj)
            this.props.showLogin();
        this.props.getCustomerList(3);
    }

    handleSearch=(formValues)=>
    {
        this.props.getReportPreview("getSMSReport",formValues,(base64Report)=>{
            this.setState({
                base64Report,
                report: parseCsvText(decodeBase64ToText(base64Report))
            });
        });
    };

    handleDownload=()=>
    {
        handleBase64Response(this.state.base64Report,"sms.csv");
    };

    render()
    {
        return <MainLayout title={'logo'} size={'medium'} variant="report"
                           reportTitle="Consumo SMS y Llamadas"
                           reportDescription="Revisa el consumo de mensajes y llamadas por cliente para validaciones comerciales.">
            <Form className="report-filter-panel" layout="vertical" name="operations"
                  onFinish={this.handleSearch}>
                <ReportFilterHeader/>
                <div className="report-filter-fields">
                    <CustomerFilterItem customerList={this.props.customerList}/>
                    <DateRangeFilterItem/>
                </div>
                <ReportFilterActions>Generar reporte</ReportFilterActions>
            </Form>
            <ReportResultTable title="Consumo SMS y Llamadas" parsedReport={this.state.report} onDownload={this.handleDownload}/>
        </MainLayout>;
    }
}

function mapStateToProps(state) {
    return {
        login: state.login,
        customerList:state.customer.customerList
    }
}
export default connect(mapStateToProps, {getCustomerList,showLogin,getReportPreview})(SMSOperations);
